import { myWalletClickHelper, Pixall } from 'reaxl-analytics-handlers';

import { addListingTriggerData, getInventoryOwnerById, isPremiumSpotlight, isVDP } from '@/analytics/utilities';

const sendGoogleClickPaymentEvent = (data, option) => {
    const { text, clickType, listingPosition } = data;
    myWalletClickHelper({
        eventResult: `text-link::open::${text}`,
        eventData: {
            vehicle: {
                clickType,
                listingPosition,
            },
        },
    }, option);
};

/**
 * @summary Sends Google and Pixall events for payment CTA on listing click
 * @events cmp
 */
export async function listingPaymentCTAClick({ data = {}, dataLayer, state = {} }, option) {
    const { inventoryId, par = '', clickType = '', paginatedListingIndex = '', placement } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);

    const { owner, style, specifications } = inventory;

    const bodyStyle = Array.isArray(style) && style.length ? style[0]?.toUpperCase() : undefined;
    const exteriorColor = specifications?.color?.value.toUpperCase();

    const labelSuffix = placement ? `::${placement}` : '';
    const cmp = `estm_pymt_walt${labelSuffix}`;
    const listingType = isPremiumSpotlight(par) ? 'highlight' : undefined;
    const cdl = addListingTriggerData(par, {
        eventProperties: {
        },
    });

    Pixall.sendClickEvent({
        cdl,
        inventory,
        eventType: 'click',
        label: cmp,
        eventSource: 'vehicle',
        listingCode: owner?.id,
        listingType,
        bodyStyle,
        exteriorColor,
        fuelEconomy: specifications?.mpg?.value,
        par,
        pixallData: {
            clickTypeToListingType: isVDP(dataLayer),
        },
    }, dataLayer, option);

    sendGoogleClickPaymentEvent({ text: 'see-estimated-payment', clickType, listingPosition: paginatedListingIndex }, option);

    return { cmp };
}
